module.exports = __webpack_public_path__ + "img/fidenza.8a203670.jpg";